import { exactagScope, exactagState } from "../core/utils.js";
import { type ExactagData, exactagData } from "../core/data.js";
import type { ExactagSync } from "../sync.types.js";

export const varnishData: ExactagSync["varnish"] = {
  data: [],
  version: "0.8.9",
};

/*    */
/*                                       */
/*  */
/*                                                      */
/*  */
/*       */
/*                                                                     */
/*                                                  */

const log = exactagScope.scope("collect.varnish");

/*                                                            */
const variationIdSearchPattern = /variationId=([a-zA-Z0-9_-]*)/;

/**
 *
 *
 *
 *
 *
 */
export function getVarnishURL(path = "/user/performanceMarketing"): string {
  /*                                                                            */
  const varnishURL = new URL(path, window.location.href);

  /*                                          */
  /*                                 */

  const { hash } = window.location;
  if (variationIdSearchPattern.test(hash)) {
    varnishURL.searchParams.set("variationId", hash.match(variationIdSearchPattern)![1]);
  }

  return varnishURL.href;
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export async function updateVarnishData(scriptUrl: string): Promise<void> {
    try {
      await import(scriptUrl);
      log.info("Varnish script loaded and executed, varnish complete");
      exactagState.varnishComplete = true;
    } catch (error) {
      log.error("Error loading varnish script", error);
    };
}

/**
 *
 *
 */
export function addVarnishData(newData: ExactagData, varnish = varnishData): typeof varnishData {
  varnish.data.push(newData);
  log.debug("Added new varnish data", newData);
  return varnish;
}

/**
 *
 *
 *
 *
 *
 */
export function appendVarnishData(data = exactagData, varnish = varnishData): ExactagData {
  if (exactagState.isFirstRun) {
    log.debug("Append varnish data to exactag data");
    Object.assign(data, ...varnish.data);
    exactagState.isFirstRun = false;
  }

  return data;
}
